import React from "react";
import { Switch, SwitchOnChangeData } from "@fluentui/react-components";
import { PaymentType } from "../../../../common";
import { useStyles } from "./PaymentOptionStyles";

type PaymentOptionProps = React.PropsWithChildren<{
  disabled?: boolean;
  label: React.ReactNode;
  paymentType: PaymentType;
  selected: boolean;
  onSelect: (paymentType: PaymentType, data: SwitchOnChangeData) => void;
}>;

export const PaymentOption = ({
  children,
  disabled,
  label,
  paymentType,
  selected,
  onSelect,
}: PaymentOptionProps) => {
  const styles = useStyles();
  function getLabelText(label: React.ReactNode): string {
    console.log("getLabelText", label);
    if (typeof label === "string") return label;
    if (typeof label === "number") return label.toString();
    if (React.isValidElement(label)) return getLabelText(label.props.children);
    if (Array.isArray(label)) return label.map(getLabelText).join(" ");
    return "";
  }
  return (
    <div className={styles.container} data-testid="PaymentOption">
      <div className={styles.header}>
        {label}
        <Switch
          aria-label={getLabelText(label) || "Switch Payment Type"}
          data-testid={`${paymentType}Switch`}
          id={paymentType}
          disabled={disabled}
          checked={selected}
          onChange={(e, d) => onSelect(paymentType, d)}
          tabIndex={1}
        />
      </div>
      {selected && children && <div className={styles.main}>{children}</div>}
    </div>
  );
};
